import { useCallback, useEffect, useState } from 'react'

import { useLoaderData, useRouter } from '@tanstack/react-router'
import { ApplicationWebPageDetail } from 'commons/types/DTO/bank'
import { Toast } from 'ui/components/Toast'

import useApplicationFinalization from './useApplicationFinalization'

const useApplicationDetails = () => {
  const router = useRouter()
  const data = useLoaderData({ from: '/_app/onboarding/applications/$applicationId' }) as ApplicationWebPageDetail

  const { applicationID, enableApplicationInProgressWarning } = data

  const [isShowBankAccountsDialog, setShowBankAccountsDialog] = useState<boolean>(false)

  const { routine: finalizeApplication, isLoading: isFinalizing } = useApplicationFinalization({
    onSuccess: async () => {
      Toast.success('Application has been finalized')
      setShowBankAccountsDialog(false)
      await router.invalidate()
    },
    onError: () => {
      Toast.error('Something went wrong')
    }
  })

  useEffect(() => {
    if (enableApplicationInProgressWarning) {
      Toast.info('RFI Pending', 'Application in progress')
    }
  }, [enableApplicationInProgressWarning])

  const handleCancel = useCallback(() => setShowBankAccountsDialog(false), [])

  const handleSubmit = useCallback(async () => {
    if (!applicationID) {
      return
    }
    await finalizeApplication({ applicationId: applicationID })
  }, [finalizeApplication, applicationID])

  const handleFinalization = useCallback(() => setShowBankAccountsDialog(true), [])

  return {
    application: data,
    isShowBankAccountsDialog,
    isFinalizing,
    onCancel: handleCancel,
    onFinalizeApplication: handleFinalization,
    onSubmit: handleSubmit
  }
}

export default useApplicationDetails
